import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var feedbackDetailsRes;
export const feedbackDetailsTodo = createAsyncThunk('feedbackDetails', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/view_feedback_details',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "fk_user_id": data.user_id,
                "course_id": data.course_id,
                "fk_training_id": data.training_id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return feedbackDetailsRes = res.data
    } catch (error) {
        return feedbackDetailsRes = error.response.data
    }
})


const feedbackDetailsSlice = createSlice({
    name: 'feedbackDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(feedbackDetailsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('feedbackDetails', state.data)
            }
        });
        builder.addCase(feedbackDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default feedbackDetailsSlice.reducer; 